<template>
  <div>
    <template v-for="(searches, group) in groupedSearches">
      <v-subheader :key="group">
        {{ $tc(`message.searcher.tab.${group}`) }}
      </v-subheader>
      <v-list-tile v-for="search in searches"
                   style="background: white"
                   subheader
                   @click="$emit('input', search)"
                   :key="search.uuid">
        <v-list-tile-avatar>
          <v-icon>{{ search.uuid === selected ? 'done' : 'search' }}</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{ translate(search.name) }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
    <v-list-tile v-if="hasSearches && showOnlySearchesForEntity">
      <v-list-tile-content class="caption nx-text--level-1">
        <i>{{ showingOnlyEntitySearchesMsg }}</i>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile v-if="!hasSearches && showEmptyMessage">
      <v-list-tile-content class="caption nx-text--level-1">
        <i>{{ emptyMessage }}</i>
      </v-list-tile-content>
    </v-list-tile>
  </div>
</template>

<script>

import ListSavedSearches from '@/modules/saved-searches/mixins/list-saved-searches';
import { translateCandidates } from '@/utils';

export default {
  name: 'nx-saved-searches-menu-list',
  mixins: [ListSavedSearches],
  props: {
    showEmptyMessage: Boolean,
    selected: String,
  },
  computed: {
    showingOnlyEntitySearchesMsg() {
      return this.$t('message.searcher.savedSearch.showingOnlyEntitySearches', {
        entity: this.$t(`message.searcher.tab.${this.showOnlySearchesForEntity}`),
      });
    },
  },
  methods: {
    translate(translatable, translationVars = []) {
      return translateCandidates(
        [
          `message.${translatable}`,
          translatable,
        ],
        translatable,
        translationVars,
      );
    },
  },
};
</script>
